import { render } from "./AppInputUrl.vue?vue&type=template&id=71760992"
import script from "./AppInputUrl.vue?vue&type=script&lang=ts"
export * from "./AppInputUrl.vue?vue&type=script&lang=ts"
script.render = render

export default script